import { Injectable } from '@angular/core';
import { BaseService } from '@core/service/base.service';
import { HttpClient } from '@angular/common/http';


@Injectable({ providedIn: 'root' })
export class JyActionService extends BaseService {

  private url = 'api/action';


  constructor(http: HttpClient) {
    super(http);
  }

  getUrl(): string {
    return this.url;
  }

}

